import styled from 'styled-components';
import { Headline3 } from '../../../common/typography';

export const MyDailyBoosterContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.s};
`;

// not working -> rafael
export const MyDailyBoosterTitle = styled(Headline3)`
  display: flex;
  justify-content: center;  
  margin-bottom: ${({ theme }) => theme.spacing.m};
`;

export const MyDailyTabsContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const MyDailyBoosterTabContainerWrapper = styled.div`
  gap: ${({ theme }) => theme.spacing.s};
  display: flex;
  justify-content: space-between;
  list-style: none;
  overflow-x: auto;
  overflow-y: hidden;
`;

export const MyDailyBoosterTabContent = styled.div``;

export const MyDailyBoosterButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.s};
`;
